// Shared React Query helpers.
//
// ─── pausePollingOnError ──────────────────────────────────────────────────────
// Incident (live prod): a platform user holding a STALE `X-Practice-ID` for a
// practice they aren't assigned to drove /dashboard/metrics and /notifications
// into a permanent 403 PRACTICE_SWITCH_DENIED. A plain numeric `refetchInterval`
// keeps firing on a fixed cadence even while the query is erroring, so the
// pollers re-hit the 403 forever and eventually trip the backend rate limiter →
// a 429 flood.
//
// Use this in place of a bare `refetchInterval: <ms>` on any polling query. It
// pauses the interval the moment a fetch fails and resumes once a fetch succeeds
// again — so no permanent error can hammer the API.
//
// Why `fetchFailureCount > 0` is the right predicate: with `retry: false`,
// React Query resets fetchFailureCount to 0 at the start of each fetch and the
// retryer sets it to 1 on a failed attempt. So after any failed fetch it is ≥1
// and the interval is paused; after a successful fetch it is back to 0 and the
// interval (intervalMs) resumes. This also covers the "stale data still cached,
// background refetch failing" case, where query.state.status stays 'success'.
export function pausePollingOnError(intervalMs: number) {
  return (query: { state: { fetchFailureCount: number } }): number | false =>
    query.state.fetchFailureCount > 0 ? false : intervalMs;
}
